export const handleGtmAddToCart = function (
    name: string,
    id: string,
    price: string,
    quantity: string,
): void {
    window.dataLayer = window.dataLayer || []

    // Clear previous ecommerce data
    window.dataLayer.push({ ecommerce: null })

    const gtmData = {
        event: 'add_to_cart',
        ecommerce: {
            currency: 'EUR',
            value: Number(price).toFixed(2),
            items: [
                {
                    item_name: name,
                    item_id: id,
                    price: Number(price).toFixed(2),
                    quantity,
                },
            ],
        },
    }

    window.dataLayer.push(gtmData)
}
